let defaultBaseUrl = ''
let shdHost = ''

if (process.env.NODE_ENV === 'production') {
  defaultBaseUrl = '/prod-api'
  shdHost = '/erp'
} else {
  // defaultBaseUrl = 'http://192.168.3.16:10005'
  defaultBaseUrl = 'https://back.walands.com'
  // shdHost = 'http://192.168.3.135:901'
  shdHost = 'https://erp.walands.com'
}

export default {
  defaultBaseUrl,
  shdHost,
  ak: 'zhangchuanbeizhu',
}
